import { render, staticRenderFns } from "./IngressClass.vue?vue&type=template&id=7b01867c&"
import script from "./IngressClass.vue?vue&type=script&lang=js&"
export * from "./IngressClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports